(() => {
  "use strict";

  // ============================================
  // Global Keyboard Accessibility / Interaction
  // ============================================

  const SELECTORS = [
    "a[href]",
    "button",
    "input",
    "select",
    "textarea",
    "[tabindex]",
    "[role='button']",
    "[role='link']",
    "[role='menuitem']",
    "[role='tab']",
    "[role='checkbox']",
    "[role='radio']",
    "[role='switch']",
    "[role='option']",
    "[contenteditable='true']",
    "[data-keyboard]"
  ].join(",");

  // Make elements with click handlers / custom interactive
  // attributes keyboard accessible.
  document.addEventListener("keydown", (event) => {
    const target = event.target.closest(SELECTORS);

    if (!target) return;

    // ENTER activates most interactive elements.
    if (event.key === "Enter") {
      if (
        target.matches(
          "[role='button'], [role='link'], [role='menuitem'], [data-keyboard]"
        )
      ) {
        event.preventDefault();
        target.click();
      }
    }

    // SPACE activates buttons/custom controls.
    if (event.key === " ") {
      if (
        target.matches(
          "button, [role='button'], [role='checkbox'], [role='switch'], [data-keyboard]"
        )
      ) {
        event.preventDefault();
        target.click();
      }
    }
  });

  // --------------------------------------------
  // Make clickable non-semantic elements focusable
  // --------------------------------------------

  document.querySelectorAll(
    "[onclick], [data-keyboard], [role='button'], [role='link']"
  ).forEach((element) => {
    const isNaturallyFocusable =
      element.matches(
        "a[href], button, input, select, textarea, summary"
      );

    if (!isNaturallyFocusable && !element.hasAttribute("tabindex")) {
      element.setAttribute("tabindex", "0");
    }
  });

  // --------------------------------------------
  // Escape closes common UI components
  // --------------------------------------------

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    // Close elements marked with data-keyboard-close
    document
      .querySelectorAll("[data-keyboard-open='true']")
      .forEach((element) => {
        element.setAttribute("data-keyboard-open", "false");
        element.classList.remove("open", "active", "visible");

        const closeButton = element.querySelector(
          "[data-close], .close, .modal-close, [aria-label='Close']"
        );

        if (closeButton) {
          closeButton.click();
        }
      });

    // Close open dialogs
    document.querySelectorAll("dialog[open]").forEach((dialog) => {
      if (typeof dialog.close === "function") {
        dialog.close();
      }
    });
  });

  // --------------------------------------------
  // Global keyboard shortcuts
  // --------------------------------------------

  document.addEventListener("keydown", (event) => {
    // Ignore shortcuts while typing.
    const typing =
      event.target.matches(
        "input, textarea, select, [contenteditable='true']"
      );

    if (typing) return;

    // "/" = focus search
    if (event.key === "/") {
      const search =
        document.querySelector(
          "input[type='search'], input[name='search'], #search"
        );

      if (search) {
        event.preventDefault();
        search.focus();
      }
    }

    // Home = go to top
    if (event.key === "Home") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }

    // End = go to bottom
    if (event.key === "End") {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth"
      });
    }
  });

  // --------------------------------------------
  // Accessible focus styling
  // --------------------------------------------

  const style = document.createElement("style");

  style.textContent = `
    :focus-visible {
      outline: 3px solid #2563eb !important;
      outline-offset: 3px !important;
      border-radius: 3px;
    }

    [data-keyboard],
    [role="button"],
    [role="link"] {
      cursor: pointer;
    }
  `;

  document.head.appendChild(style);

  // --------------------------------------------
  // Automatically add keyboard support to
  // elements marked as data-keyboard
  // --------------------------------------------

  document.querySelectorAll("[data-keyboard]").forEach((element) => {
    if (!element.hasAttribute("tabindex")) {
      element.setAttribute("tabindex", "0");
    }

    if (!element.hasAttribute("role")) {
      element.setAttribute("role", "button");
    }
  });

  console.log("Global keyboard interaction enabled.");
})();

(function () {
  'use strict';

  /*
   * WHITE DUCK PDP KEYBOARD FIX
   *
   * Only runs on product pages.
   */

  var isProductPage = document.body.classList.contains('template-product');

  if (!isProductPage) {
    return;
  }

  /*
   * Make sure keyboard focus is not disabled globally.
   */
  document.documentElement.style.removeProperty('pointer-events');

  /*
   * DO NOT disable body scrolling here.
   * We only make sure the PDP can receive focus.
   */
  document.body.removeAttribute('inert');

  /*
   * Remove inert from the main PDP containers if some
   * theme script accidentally added it.
   */
  document.querySelectorAll('[inert]').forEach(function (element) {
    element.removeAttribute('inert');
  });


  /*
   * DEBUG:
   *
   * If Tab is being blocked by another script,
   * this will show which element receives focus.
   */
  document.addEventListener(
    'focusin',
    function (event) {
      console.log(
        '[PDP KEYBOARD] Focus:',
        event.target
      );
    },
    true
  );


  /*
   * Find all normal keyboard interactive elements.
   */
  function getFocusableElements() {

    return Array.from(
      document.querySelectorAll(
        'a[href],' +
        'button:not([disabled]),' +
        'input:not([disabled]),' +
        'select:not([disabled]),' +
        'textarea:not([disabled]),' +
        '[tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {

      var style = window.getComputedStyle(element);

      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        !element.hasAttribute('disabled') &&
        !element.hasAttribute('inert')
      );

    });

  }


  /*
   * Test whether the browser is actually able
   * to focus PDP controls.
   */
  window.whiteDuckTestPDPKeyboard = function () {

    var elements = getFocusableElements();

    console.log(
      '[PDP KEYBOARD] Focusable elements:',
      elements
    );

    if (!elements.length) {

      console.warn(
        '[PDP KEYBOARD] NO FOCUSABLE ELEMENTS FOUND'
      );

      return;

    }

    elements.forEach(function (element, index) {

      console.log(
        index,
        element.tagName,
        element,
        'tabindex:',
        element.getAttribute('tabindex')
      );

    });

  };


  /*
   * Run after page load.
   */
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      function () {
        setTimeout(
          window.whiteDuckTestPDPKeyboard,
          1000
        );
      }
    );

  } else {

    setTimeout(
      window.whiteDuckTestPDPKeyboard,
      1000
    );

  }

})();

document.addEventListener('keydown', function (event) {
  const button = event.target.closest('[role="button"]');

  if (!button) return;

  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    button.click();
  }
});

$('.slider-for, .slider-nav').on('init afterChange', function(event, slick) {
  slick.$slides.each(function(i, el) {
    var isActive = $(el).hasClass('slick-active');
    $(el).find('a, button, input, [tabindex]').attr('tabindex', isActive ? '0' : '-1');
    $(el).attr('aria-hidden', isActive ? 'false' : 'true');
  });
  // clones ko permanently hide from AT
  slick.$slideTrack.find('.slick-cloned').attr('aria-hidden', 'true')
    .find('a, button, input').attr('tabindex', '-1');
});